export const handleExpiredToken = {
    retry: 1,
    retryDelay: 1000,
};
